module.exports = __webpack_public_path__ + "static/media/20150430_007032_084509.a495a156.mp3";